// extracted by mini-css-extract-plugin
module.exports = {"text":"text-371O9","button":"button-zlQwO","refuse":"refuse-3QIPh"};